import React from 'react';

const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.1663 5.83301V2.66634C10.1663 2.2061 9.79324 1.83301 9.33301 1.83301H2.66634C2.2061 1.83301 1.83301 2.2061 1.83301 2.66634V9.33301C1.83301 9.79324 2.2061 10.1663 2.66634 10.1663H5.83301M6.66634 5.83301H13.333C13.7932 5.83301 14.1663 6.2061 14.1663 6.66634V13.333C14.1663 13.7932 13.7932 14.1663 13.333 14.1663H6.66634C6.2061 14.1663 5.83301 13.7932 5.83301 13.333V6.66634C5.83301 6.2061 6.2061 5.83301 6.66634 5.83301Z"
        stroke="#225AEA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
